export default {
    social(state){
        return state.socialMedia
    }
}